import * as types from '../constants/actionTypes';

const initialState = {
  memberId: 3,
  firstname: "",
  lastname: "",
  MPI: "",
  token: "",
  insuranceCards: null,
  benefits: null,
  incentives: null,
  plans: null,
}

const member = (state = initialState, action) => {
   switch (action.type) {

    // case types.RECIEVE_PROFILE:
    //   return Object.assign({}, state, {
    //     member: action.profile
    //   });
    //   break;

    
    case types.RECEIVE_INSURANCE_CARD:
      return Object.assign({}, state, {
        insuranceCards: action.cards
      });
      break;

    case types.RECEIVE_PLANS:
      console.log("action.plans", action.plans)
      return {
        ...state, 
        plans: action.plans
      };
      break;

    // case types.RECEIVE_BENEFITS:
    //   return Object.assign({}, state, {
    //     benefits: action.benefits
    //   })

    // case types.RECEIVE_INCENTIVES:
    //   return Object.assign({}, state, {
    //     incentives: action.incentives
    //   })


 
    default:
      return state;
  }
  
}

export default member



// WEBPACK FOOTER //
// ./src/reducers/member.js